import { CompanyLocationModel } from './companyLocationModel';

export class EditCompanyLocationModel extends CompanyLocationModel{
}
